module.exports = __webpack_public_path__ + "media/images/ico-duplicate-bf72811c.svg";